module.exports = __webpack_public_path__ + "static/media/list.369f0803.svg";